import { isString } from 'lodash';

const isTempTag = (tempTag) => (isString(tempTag) ? tempTag.includes('tempTag') : false);

export default isTempTag;
